import React from 'react';

import {
  View,
  Platform,
  Animated,
  StatusBar,
  Dimensions,
  Text,
  TouchableOpacity,
} from 'react-native';
import AppIntro from 'react-native-app-intro';
import Swiper from './Swiper';
import SkipButton from 'react-native-app-intro/components/SkipButton';
import RenderDots from 'react-native-app-intro/components/Dots';
import { pOrT } from '../components/styleConstants';
import { IS_PHONE } from './appConstants';

const windowsWidth = Dimensions.get('window').width;
const windowsHeight = Dimensions.get('window').height;

const DoneButton = ({
  styles,
  onDoneBtnClick,
  onNextBtnClick,
  rightTextColor,
  isDoneBtnShow,
  doneBtnLabel,
  nextBtnLabel,
}) => {
  return (
    <View style={styles.btnContainer}>
      <TouchableOpacity
        style={styles.full}
        onPress={isDoneBtnShow ? onDoneBtnClick : onNextBtnClick}
      >
        {isDoneBtnShow ? (
          <View style={styles.full}>{doneBtnLabel}</View>
        ) : (
          <View style={styles.full}>{nextBtnLabel}</View>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default class AppIntroWrapper extends AppIntro {
  renderPagination = (index, total, context) => {
    let isDoneBtnShow;
    let isSkipBtnShow;
    if (index === total - 1) {
      this.setDoneBtnOpacity(1);
      this.setSkipBtnOpacity(0);
      this.setNextOpacity(0);
      isDoneBtnShow = true;
      isSkipBtnShow = false;
    } else {
      this.setDoneBtnOpacity(0);
      this.setSkipBtnOpacity(1);
      this.setNextOpacity(1);
      isDoneBtnShow = false;
      isSkipBtnShow = true;
    }
    return (
      <View
        style={[
          {
            position: 'absolute',
            bottom: pOrT(30, this.props.inModal ? undefined : 100),
            ...(this.props.inModal && !IS_PHONE ? { top: pOrT(undefined, 500) } : {}),
            flexDirection: 'row',
            flex: 1,
            width: this.props.videoWidth,
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        {this.props.showSkipButton ? (
          <View
            style={{
              width: 100,
            }}
          >
            <SkipButton
              {...this.props}
              {...this.state}
              isSkipBtnShow={isSkipBtnShow}
              styles={this.styles}
              onSkipBtnClick={() => this.props.onSkipBtnClick(index)}
            />
          </View>
        ) : (
          <View style={this.styles.btnContainer} />
        )}
        {this.props.showDots && (
          <View
            style={{
              marginBottom: -3,
              paddingRight: 15,
              paddingLeft: 25,
              flexDirection: 'row',
            }}
          >
            {RenderDots(index, total, {
              ...this.props,
              styles: this.styles,
            })}
          </View>
        )}
        {this.props.showDoneButton ? (
          <View
            style={{
              width: 80,
            }}
          >
            <DoneButton
              {...this.props}
              {...this.state}
              isDoneBtnShow={isDoneBtnShow}
              styles={this.styles}
              onNextBtnClick={this.onNextBtnClick.bind(this, context)}
              onDoneBtnClick={this.props.onDoneBtnClick}
            />
          </View>
        ) : (
          <View style={this.styles.btnContainer} />
        )}
      </View>
    );
  };

  render() {
    const childrens = this.props.children;
    const { pageArray } = this.props;
    let pages = [];
    let androidPages = null;
    if (pageArray.length > 0) {
      pages = pageArray.map((page, i) => this.renderBasicSlidePage(i, page));
    } else {
      if (Platform.OS === 'ios') {
        pages = childrens.map((children, i) => this.renderChild(children, i, i));
      } else {
        androidPages = childrens.map((children, i) => {
          const { transform } = this.getTransform(i, (-windowsWidth / 3) * 2, 1);
          pages.push(<View key={i} />);
          return (
            <Animated.View
              key={i}
              style={[
                {
                  position: 'absolute',
                  height: windowsHeight,
                  width: windowsWidth,
                  top: 0,
                },
                {
                  ...transform[0],
                },
              ]}
            >
              {this.renderChild(children, i, i)}
            </Animated.View>
          );
        });
      }
    }

    if (this.isToTintStatusBar()) {
      StatusBar.setBackgroundColor(
        this.shadeStatusBarColor(this.props.pageArray[0].backgroundColor, -0.3),
        false,
      );
    }

    return (
      <View>
        {androidPages}
        <Swiper
          loop={false}
          index={this.props.defaultIndex}
          renderPagination={this.renderPagination}
          onMomentumScrollEnd={(e, state) => {
            if (this.isToTintStatusBar()) {
              StatusBar.setBackgroundColor(
                this.shadeStatusBarColor(this.props.pageArray[state.index].backgroundColor, -0.3),
                false,
              );
            }

            this.props.onSlideChange(state.index, state.total);
          }}
          onScroll={Animated.event([{ x: this.state.parallax }])}
        >
          {pages}
        </Swiper>
      </View>
    );
  }
}
